const semanticClassNames = {
  root: 'progress-bar',
} as const;

export default semanticClassNames;
